import { Notifications } from '@/modules/notifications/types';
import { all_roles } from '@/utils';

const access_roles = {
  [Notifications.Pages.NOTIFICATIONS]: all_roles,
  [Notifications.Pages.SETTINGS]: all_roles,
  [Notifications.Pages.NOTIFICATIONS_SETTINGS]: all_roles,
};

export default access_roles;
